import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container inner">
        <span className="muted">{t('common.appName')}</span>
        <span className="spacer" />
        <Link to="/datenschutz">{t('nav.privacy')}</Link>
      </div>
    </footer>
  );
}
